export default class Pathes {
  static Auth = class {
    static login = '/auth/founder/login/';
    static forgotPassword = '/auth/forgotPassword/';
    static resetPassword = '/auth/resetPassword/';
    static verifyToken = '/auth/verifyToken/';
    static changePassword = '/auth/changePassword/';
    static coFounderInvite = '/auth/doGenerateInviteLink/';
    static coFounderValidateInvite = `/auth/doValidateInviteCode/`;
    static refreshToken = '/token/refresh/';
    static logout = '/logout/';
  };

  static User = class {
    static registration = 'founders/registration/';
    static contactInfoStepTwo = '/founders/registration/step_two/';
    static profile = '/founders/profile/';
    static sectors = '/sectors/';
    static photo = '/users/doUpdatePhoto/';
    static updateProfilePhoto = '/users/doUpdateProfilePhoto/';
    static careerCreate = '/founders/careers/doCreateCareer/';
    static careerDelete = '/founders/careers/doDeleteCareers/';
    static educationCreate = '/founders/educations/doCreateEducation/';
    static educationDelete = '/founders/educations/doDeleteEducations/';
    static updateProfileAbout = '/founders/doUpdatePersonalInfo/';
    static updateProfileContact = '/founders/doUpdateContactInfo/';
    static updateCompany = '/companies/doUpdateCompany/';
    static updatePromo = '/companies/doUpdatePromo/';
    static profileMissingDetails = '/founders/missing_info/';
    static company = companyID => `/companies/${companyID}/`;
    static career = careerID => `/founders/careers/${careerID}/doUpdateCareer/`;
    static education = educationID => `/founders/educations/${educationID}/doUpdateEducation/`;
    static myLocation = '/my_location/';
    static startupBankStatement = id => `/startup_bank_statements/${id}/`;
    static validatePhoneNumber = '/validate_code/';
    static sentCodes = '/send_code/';
  };

  static Fundraising = class {
    static status = '/founders/fundraising_status/';
    static statusById = fundraisingId => `/fundraising/${fundraisingId}/status/`;
    static loanGroups = '/fundraising/loan_groups/';
    static setGoal = '/founders/fundraising_goal/';
    static swapList = '/founders/accepted_swaps/';
    static successfulSwaps = '/founders/successful_swaps/';
    static resetFundraising = '/founders/doResetGoal/';
    static partnerCounts = '/founders/partner_counts/';
    static generalFounders = '/strategy_founders/general/';
    static strategyCustomFounders = '/strategy_founders/custom/';
    static customPartners = '/founders/custom_partners/';
    static holdCustomPartners = '/founders/on_hold_selected_founders/';
    static latestFundraisingPartners = '/founders/latest_fundraising_partners/';
    static bulkSwapSelect = '/founders/bulk_select/';
    static fundraisingRecalculation = '/founders/recalculate_goal/';
    static fundraisingRecalculationById = fundraisingId =>
      `/founders/${fundraisingId}/recalculate_goal/`;
    static nextStatus = 'founders/next_fundraising_status/';
    static accepted = '/founders/accepted_swaps/';
    static incoming = '/founders/incoming_swaps/';
    static rejected = '/founders/rejected_swaps/';
    static potential = '/founders/potential_partners/';
    static requestSwap = '/swaps/doSendSwapRequest/';
    static acceptSwap = id => `/swaps/${id}/doAcceptSwapRequest/`;
    static rejectSwap = id => `/swaps/${id}/doRejectSwapRequest/`;
    static cancelSwapRequest = id => `/swaps/${id}/doCancelSwapRequest/`;
    static acceptOrDeclineFundraising = '/founders/doAcceptOrDeclineParticipatingStatus/';
    static termsOfUseStatus = '/founders/accept-terms-of-use/';
    static riskFactorStatus = '/founders/risk_factor_status/';
    static tariffPlans = '/founders/tariffs/';
    static fpgAssets = '/founders/fpg_assets_form_save/';
    static application = '/fundraisings/application/';
    static applicationStatus = '/fundraisings/application/status/';
    static applicationStatusById = applicationId =>
      `/fundraisings/application/${applicationId}/status/`;
    static applicationList = '/fundraisings/info/';
    static applicationCreate = '/fundraisings/application/create/';
    static applicationSubmit = applicationId =>
      `/fundraisings/application/${applicationId}/submit/`;
    static borrowerConfirmFundraising = '/founders/borrower/confirm_participation/';
    static lenderApplicationList = '/founders/lender/application_list/';
    static lenderSetGoal = '/founders/lender/fundraising_goal/';
    static lenderResetFundraising = '/founders/lender/doResetGoal/';
    static lenderFundraisingStatus = companyId => `/founders/lender/${companyId}/fundraising/`;
    static lenderFpgAssets = '/founders/lender/fpg_assets_form_save/';
  };

  static Common = class {
    static founderInfo = id => `/founders/${id}/`;
    static file = '/files/';
    static countries = '/countries/';
    static chatwootIdentity = '/chatwoot/identity/';
  };

  static Company = class {
    static detail = companyID => `/investors/companies/${companyID}/`;
    static detailBySlug = slug => `/companies/${slug}/`;
    static participating = '/public/startups_batch/';
    static participatingStartups = '/companies/participating_companies/';
    static inactiveStartups = '/companies/inactive_companies/';
  };

  // TODO remove
  static Stripe = class {
    static session = '/create_checkout_session/';
    static calculate = '/calculate_total_amount/';
    static info = sessionID => `/payment_sessions/${sessionID}/`;
  };

  static LHV = class {
    static session = '/create_lhv_payment_session/';
    static methods = '/payment_methods_with_fees/';
    static paymentSession = '/lhv_payment_session/';
  };

  static File = class {
    static file = '/files/';
    static photo = '/images/';
  };

  static Payments = class {
    static withdrawInfo = '/withdraw_info/';
    static withdrawHistory = '/withdraw_requests/';
    static withdrawRequest = reqID => `/withdraw_requests/${reqID}/`;
    static withdrawReq = '/withdraw/';
    static nextPayment = '/next_payment/';
    static schedule = '/payment_schedule/';
    static prepay = '/prepay_info/';
    static doPrepay = '/loans/doPrepayLoan/';
    static deadlineDetails = deadline => `/deadline_details/${deadline}/`;
    static pendingTransactions = '/payment_sessions/';
    static bankDetails = '/founders/bank_details/';
    static bankDetailByID = id => `/founders/bank_details/${id}/`;
    static countryInSepa = countryCode => `/sepa_check/?country_code=${countryCode}`;
    static ibanCheck = '/iban_check/';
  };

  static Dashboard = class {
    static fundraisingDates = '/founders/fundraising_dates/';
    static finances = '/founders/finances/';
    static balanceInfo = '/founders/dashboard/balance/';
    static paymentInfo = '/founders/dashboard/next_payment/';
    static depositInfo = '/founders/dashboard/deposit_totals/';
    static lenderStats = '/founders/lender/dashboard/statistics/';
  };

  static Founders = class {
    static activeList = '/participating_founders/';
    static allList = '/inactive_founders/';
    static detail = id => `/founders/${id}/doGetFounderPageDetails/`;
    static fundraisingStatus = id => `/founders/${id}/fundraising_status/`;
    static swapPartners = id => `/founders/${id}/partners/`;
    static selection = '/founders/selection/';
    static coFounders = '/founders/co_founders/';
  };

  static Activity = class {
    static list = '/activities/';
    static types = '/activity_types/';
    static cashMovements = '/founders/reports/cash_movements/';
    static portfolioMovements = '/founders/reports/portfolio_movements/';
    static taxReport = '/founders/reports/tax/';
  };

  static Loans = class {
    static list = '/founder/fundraisings/';
    static detail = id => `/founder/fundraisings/${id}/`;
    static swapPartners = '/loans/doGetLoanSwapPartners/';
    static loanTerms = '/loan_groups/founder_terms/';
    static paymentHistory = id => `/loan_payment_histories/${id}/`;
    static refinBannerStatus = '/founders/refinancing_banner/';
    static refinApply = '/founders/refinancing/';
    static availableRefinLoans = '/founder/fundraisings/available_for_refin/';
    static personalGuarantees = '/founders/personal_guarantees/';
    static shiftPayment = id => `/fundraisings/${id}/payment_schedule/reschedule/`;
    static paymentSchedule = id => `/fundraisings/${id}/payment_schedule/`;
    static lenderList = '/founders/lender/fundraisings/';
  };

  static Help = class {
    static all = '/helps/?source=investor';
    static section = source => `/mini_faqs/?page=${source}`;
    static forumMessages = '/forum_messages/';
  };

  static Reporting = class {
    static status = '/founder/take_rate_status/';
    static modes = '/founder/reporting_modes/';
    static pendingReports = '/founder/pending_reports/';
    static submittedReports = '/founder/submitted_reports/';
    static applyMode = '/founder/apply_reporting_mode/';
    static detail = id => `/founder/report_details/${id}/`;
  };
}
